export class AndonUser {
  userID: string;
  userName: string;
  password: string;
  lang: string;
  mailAddress: string;
  authorityGroup: string;
  memo: string;
  category1: string;
  category2: string;
  onlyNotificationFlg: string;
  mailSendFlg: string;
  creationDateTime: Date;
  addedInformation: string;
}
